import { useEffect, useRef, useState } from 'react';
import api from '../api';

function Home() {
  const [identifier, setIdentifier] = useState('');
  const [sessionScans, setSessionScans] = useState([]);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [errorCode, setErrorCode] = useState('');
  const [loading, setLoading] = useState(false);

  const inputRef = useRef(null);
  const successAudioRef = useRef(null);
  const errorAudioRef = useRef(null);
  const outOfStockAudioRef = useRef(null);

  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.focus();
    }

    successAudioRef.current = createTonePlayer(880, 120);
    errorAudioRef.current = createTonePlayer(300, 180);
    outOfStockAudioRef.current = createTonePlayerSequence([
      { frequency: 220, duration: 140 },
      { frequency: 180, duration: 180 }
    ]);
  }, []);

  const handleScanSale = async (e) => {
    e.preventDefault();

    const scannedIdentifier = identifier.trim();

    if (!scannedIdentifier) {
      setError('Scaneaza sau introdu un cod de produs / cod de bare');
      setErrorCode('GENERIC_SCAN_ERROR');
      setMessage('');
      if (errorAudioRef.current) {
        errorAudioRef.current();
      }
      return;
    }

    try {
      setLoading(true);
      setError('');
      setErrorCode('');
      setMessage('');

      setIdentifier('');
      if (inputRef.current) {
        inputRef.current.value = '';
        inputRef.current.focus();
      }

      const response = await api.post('/scanSale', {
        identifier: scannedIdentifier
      });

      const product = response.data.product;

      setSessionScans((prev) => [
        {
          id: product.id + '-' + Date.now(),
          productCode: product.id,
          productName: product.productName,
          quantity: product.quantity,
          barcode: product.barcode || product.id,
          scannedAt: new Date().toISOString()
        },
        ...prev
      ]);

      setMessage('Scanare efectuata: ' + product.productName);

      if (successAudioRef.current) {
        successAudioRef.current();
      }

      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }, 50);
    } catch (err) {
      const backendCode =
        (err && err.response && err.response.data && err.response.data.code) ||
        'GENERIC_SCAN_ERROR';

      const backendMessage =
        (err && err.response && err.response.data && err.response.data.error) ||
        err.message ||
        'A aparut o eroare la scanarea produsului';

      setError(backendMessage);
      setErrorCode(backendCode);
      setMessage('');

      if (backendCode === 'OUT_OF_STOCK') {
        if (outOfStockAudioRef.current) {
          outOfStockAudioRef.current();
        }
      } else {
        if (errorAudioRef.current) {
          errorAudioRef.current();
        }
      }

      setTimeout(() => {
        if (inputRef.current) {
          inputRef.current.focus();
        }
      }, 50);
    } finally {
      setLoading(false);
    }
  };

  const totalScans = sessionScans.length;
  const lastScanned = sessionScans.length > 0 ? sessionScans[0] : null;


  const handleUndoLastSaleScan = async () => {
    const ok = window.confirm('Sigur vrei sa anulezi ultima scanare de vanzare?');
    if (!ok) return;

    try {
      setError('');
      setMessage('');
      await api.post('/undoLastSaleScan');
      setMessage('Ultima scanare a fost anulata cu succes');
    } catch (err) {
      setError(
        (err && err.response && err.response.data && err.response.data.error) ||
          err.message ||
          'Nu am putut anula ultima scanare'
      );
    }
  };

  return (
    <div style={pageStyle}>
      <h1 style={titleStyle}>Start vanzari</h1>
      <p style={subtitleStyle}>
        Scaneaza fiecare produs individual. Fiecare scanare scade stocul cu 1.
      </p>

      <div style={{ marginBottom: 16, display: 'flex', gap: 10 }}>
        <button type="button" onClick={handleUndoLastSaleScan} style={undoButtonStyle}>
          Undo ultima scanare
        </button>
      </div>

      <form onSubmit={handleScanSale} style={cardStyle}>
        <label style={labelStyle}>Cod produs / cod de bare</label>
        <input
          ref={inputRef}
          type="text"
          value={identifier}
          onChange={(e) => setIdentifier(e.target.value)}
          placeholder="Scaneaza aici..."
          style={inputStyle}
        />

        <button type="submit" disabled={loading} style={buttonStyle}>
          {loading ? 'Se proceseaza...' : 'Scaneaza produs'}
        </button>
      </form>

      {message ? <div style={successStyle}>{message}</div> : null}
      {error ? (
        <div style={errorCode === 'OUT_OF_STOCK' ? outOfStockStyle : errorStyle}>
          {error}
        </div>
      ) : null}

      <div style={statsRowStyle}>
        <div style={smallCardStyle}>
          <div style={smallCardLabelStyle}>Scanari sesiune</div>
          <div style={smallCardValueStyle}>{totalScans}</div>
        </div>

        <div style={smallCardStyle}>
          <div style={smallCardLabelStyle}>Ultimul produs scanat</div>
          <div style={lastProductValueStyle}>
            {lastScanned ? lastScanned.productName : '-'}
          </div>
        </div>
      </div>

      <div style={cardStyle}>
        <h2 style={sectionTitleStyle}>Scanari curente</h2>

        <div style={tableWrapStyle}>
          <table style={tableStyle}>
            <thead>
              <tr>
                <th style={thStyle}>Cod produs</th>
                <th style={thStyle}>Nume produs</th>
                <th style={thStyle}>Stoc ramas</th>
                <th style={thStyle}>Cod de bare</th>
                <th style={thStyle}>Data scanarii</th>
              </tr>
            </thead>
            <tbody>
              {sessionScans.length === 0 ? (
                <tr>
                  <td style={tdStyle} colSpan="5">
                    Nu exista scanari in sesiunea curenta.
                  </td>
                </tr>
              ) : (
                sessionScans.map((item) => (
                  <tr key={item.id}>
                    <td style={tdStyle}>{item.productCode}</td>
                    <td style={tdStyle}>{item.productName}</td>
                    <td style={tdStyle}>{item.quantity}</td>
                    <td style={tdStyle}>{item.barcode}</td>
                    <td style={tdStyle}>{formatDate(item.scannedAt)}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

function createTonePlayer(frequency, duration) {
  return () => {
    try {
      const AudioContextClass = window.AudioContext || window.webkitAudioContext;
      if (!AudioContextClass) {
        return;
      }

      const ctx = new AudioContextClass();
      const oscillator = ctx.createOscillator();
      const gain = ctx.createGain();

      oscillator.type = 'sine';
      oscillator.frequency.value = frequency;

      gain.gain.setValueAtTime(0.0001, ctx.currentTime);
      gain.gain.exponentialRampToValueAtTime(0.12, ctx.currentTime + 0.01);
      gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + duration / 1000);

      oscillator.connect(gain);
      gain.connect(ctx.destination);

      oscillator.start();
      oscillator.stop(ctx.currentTime + duration / 1000 + 0.02);
    } catch (e) {}
  };
}

function createTonePlayerSequence(sequence) {
  return () => {
    try {
      const AudioContextClass = window.AudioContext || window.webkitAudioContext;
      if (!AudioContextClass) {
        return;
      }

      const ctx = new AudioContextClass();
      let cursor = ctx.currentTime;

      sequence.forEach((step) => {
        const oscillator = ctx.createOscillator();
        const gain = ctx.createGain();

        oscillator.type = 'square';
        oscillator.frequency.value = step.frequency;

        gain.gain.setValueAtTime(0.0001, cursor);
        gain.gain.exponentialRampToValueAtTime(0.15, cursor + 0.01);
        gain.gain.exponentialRampToValueAtTime(0.0001, cursor + step.duration / 1000);

        oscillator.connect(gain);
        gain.connect(ctx.destination);

        oscillator.start(cursor);
        oscillator.stop(cursor + step.duration / 1000 + 0.02);

        cursor += step.duration / 1000 + 0.03;
      });
    } catch (e) {}
  };
}

function formatDate(dateString) {
  if (!dateString) {
    return '-';
  }

  const date = new Date(dateString);

  return date.toLocaleString('ro-RO', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit'
  });
}

const pageStyle = {
  maxWidth: '1400px',
  margin: '0 auto'
};

const titleStyle = {
  marginBottom: '8px',
  fontSize: '32px',
  color: '#111827'
};

const subtitleStyle = {
  marginTop: 0,
  marginBottom: '20px',
  color: '#4b5563'
};

const cardStyle = {
  background: '#ffffff',
  borderRadius: '12px',
  padding: '20px',
  boxShadow: '0 2px 10px rgba(0,0,0,0.08)',
  marginBottom: '20px'
};

const labelStyle = {
  display: 'block',
  marginBottom: '8px',
  fontWeight: '600',
  color: '#111827'
};

const inputStyle = {
  width: '100%',
  padding: '12px',
  fontSize: '16px',
  border: '1px solid #d1d5db',
  borderRadius: '8px',
  marginBottom: '12px',
  boxSizing: 'border-box'
};

const buttonStyle = {
  background: '#2563eb',
  color: '#ffffff',
  border: 'none',
  borderRadius: '8px',
  padding: '12px 18px',
  fontWeight: '700',
  cursor: 'pointer'
};

const undoButtonStyle = {
  background: '#f59e0b',
  color: '#111827',
  border: 'none',
  borderRadius: 10,
  padding: '12px 16px',
  cursor: 'pointer',
  fontWeight: 700
};


const successStyle = {
  background: '#dcfce7',
  color: '#166534',
  padding: '12px 16px',
  borderRadius: '10px',
  marginBottom: '16px',
  fontWeight: '600'
};

const errorStyle = {
  background: '#fee2e2',
  color: '#991b1b',
  padding: '12px 16px',
  borderRadius: '10px',
  marginBottom: '16px',
  fontWeight: '700'
};

const outOfStockStyle = {
  background: '#ef4444',
  color: '#ffffff',
  padding: '12px 16px',
  borderRadius: '10px',
  marginBottom: '16px',
  fontWeight: '800',
  border: '2px solid #991b1b'
};

const statsRowStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(220px, 1fr))',
  gap: '16px',
  marginBottom: '20px'
};

const smallCardStyle = {
  background: '#ffffff',
  borderRadius: '12px',
  padding: '18px',
  boxShadow: '0 2px 10px rgba(0,0,0,0.08)'
};

const smallCardLabelStyle = {
  color: '#6b7280',
  marginBottom: '8px',
  fontSize: '14px'
};

const smallCardValueStyle = {
  color: '#111827',
  fontWeight: '800',
  fontSize: '28px'
};

const lastProductValueStyle = {
  color: '#111827',
  fontWeight: '800',
  fontSize: '16px'
};

const sectionTitleStyle = {
  marginTop: 0,
  marginBottom: '16px',
  color: '#111827'
};

const tableWrapStyle = {
  overflowX: 'auto'
};

const tableStyle = {
  width: '100%',
  borderCollapse: 'collapse'
};

const thStyle = {
  textAlign: 'left',
  padding: '12px',
  background: '#f3f4f6',
  borderBottom: '1px solid #e5e7eb',
  color: '#111827',
  fontSize: '14px'
};

const tdStyle = {
  padding: '12px',
  borderBottom: '1px solid #e5e7eb',
  fontSize: '14px',
  color: '#111827'
};

export default Home;